<template>
  <q-btn
    ref="button"
    :label="isEmpty(column.filter) ? column.label : `${column.label}: ${getFilterValues}`"
    :class="[{
      'filter-button': true,
      'selected': !isEmpty(column.filter),
      'highlighted': highlightedButton === column.name
    }]"
    icon-right="keyboard_arrow_down"
    flat
    no-caps
  >
    <q-popover
      @show="highlightButton(column.name)"
      @hide="releaseButton()"
      :offset="popperOffset"
      ref="popover"
      anchor="bottom left"
      self="top left"
    >
      <div class="">
        <q-checkbox
          @input="column.filter.length > 1 && column.filter.shift(); search(column)"
          v-model="column.filter"
          val="1"
          label="Да"
        />
      </div>
      <div class="">
        <q-checkbox
          @input="column.filter.length > 1 && column.filter.shift(); search(column)"
          v-model="column.filter"
          val="0"
          label="Нет"
        />
      </div>
    </q-popover>
  </q-btn>
</template>

<script>
  import {
    QBtn,
    QPopover,
    QInput,
    QDatetimePicker,
    QCheckbox,
    QSearch,
    QIcon,
    date
  } from 'quasar';

  import TableFilterBase from './TableFilterBase';

  export default {
    name: 'TableFilterBool',
    components: {
      QBtn,
      QPopover,
      QInput,
      QDatetimePicker,
      QCheckbox,
      QSearch,
      QIcon
    },
    extends: TableFilterBase,
    props: {
      column: {
        type: Object,
        default: {}
      },
      columns: {
        type: Array,
        default: []
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "./style";
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TableFilter/TableFilterBool.vue